import API from './base';

const version = 'v1';

const register = '/register';
const password = '/password';

export default {
  register(payload) {
    return API.post(`${version}${register}`, payload);
  },

  forgotPassword(payload) {
    return API.post(`${version}${password}/email`, payload);
  },

  resetPassword(payload) {
    return API.post(`${version}${password}/reset`, payload);
  },

  logIn(payload) {
    return API.post(`${version}/login`, payload);
  },

  logOut() {
    return API.post(`${version}/logout`);
  },

  socialNetworkAuth(provider) {
    return API.get(`${version}/auth/${provider}`);
  },

  socialNetworkCallback(provider, payload) {
    return API.get(`${version}/auth/${provider}/callback`, {
      params: payload,
    });
  },
};
